const getEventShortName = (eventName: string) =>
  eventName.match(/\d+/g)?.join(".");

export const getIdFromEventName = (eventName: string) =>
  Number(getEventShortName(eventName));
